import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { AlgoAdjusterOrb } from "./algo-adjuster/AlgoAdjusterOrb";
import { AlgoAdjusterPanel } from "./algo-adjuster/AlgoAdjusterPanel";

// Temporarily hidden from all users. Flip back to `true` to restore the algo orb.
const ALGO_ORB_ENABLED = false;

export function GlobalAlgoAdjusterFlow() {
  const [open, setOpen] = useState(false);
  const [location] = useLocation();
  const onFeed = location === "/" || location === "/home";
  useEffect(() => {
    const openIt = () => setOpen(true);
    window.addEventListener("openAlgoAdjuster", openIt);
    return () => window.removeEventListener("openAlgoAdjuster", openIt);
  }, []);
  if (!ALGO_ORB_ENABLED) return null;
  return (
    <>
      {onFeed && <AlgoAdjusterOrb onOpen={() => setOpen(true)} />}
      <AlgoAdjusterPanel open={open} onOpenChange={setOpen} />
    </>
  );
}
